// extracted by mini-css-extract-plugin
export var label = "TermSelection-module--label--rzRkT";
export var root = "TermSelection-module--root--BiWZv";
export var select = "TermSelection-module--select--9QcWI";